import React from 'react';
import T from 'components/T';

import {
  CANS_STEP_PROVIDE,
  CANS_STEP_REVIEW,
  CANS_STEP_SELECT,
} from '../../../../../../../constants';

type Props = {
  step: string;
  provide_step?: number;
  provide_total?: number;
};

const CandidateStoryHeader = ({
  step,
  provide_step = 0,
  provide_total = 0,
}: Props) => (
  <div data-testid='candidate-story-header'>
    <div className='form-group'>
      <div className='breadcrumb-modal'>
        <span className={step === CANS_STEP_SELECT ? 'form-question' : ''}>
          <T value='components.Report.CandidateStories.Modal.selectRecord' />
        </span>
        <span className='text-muted'>&#8226;</span>
        <span className={step === CANS_STEP_PROVIDE ? 'form-question' : ''}>
          <T value='components.Report.CandidateStories.Modal.provideInformation' />
          &nbsp;
          {step === CANS_STEP_PROVIDE &&
            provide_total > 1 &&
            `(${provide_step} of ${provide_total})`}
        </span>
        <span className='text-muted'>&#8226;</span>
        <span className={step === CANS_STEP_REVIEW ? 'form-question' : ''}>
          <T value='components.Report.CandidateStories.Modal.reviewSend' />
        </span>
      </div>
      <hr />
    </div>
  </div>
);

export default CandidateStoryHeader;
